
export default {
  // Home page translations
  "welcome": "ようこそ",
  "recent_reviews": "最近のレビュー",
  "popular_airports": "人気の空港",
  "search_prompt": "空港を検索",
  "about_title": "FilmFriendlyについて",
  "about_description": "世界中の旅行者のためのフィルム写真コミュニティ。空港のセキュリティ情報を共有し、フィルムの安全な携帯をサポートします。",
  "get_started": "始める",
  "no_reviews_yet": "まだレビューはありません",
  "be_first_reviewer": "この空港の最初のレビュアーになりましょう！",
  "write_review": "レビューを書く",
  "featured_airports": "注目の空港",
  "learn_more": "詳細を見る",
  "community_statistics": "コミュニティ統計",
  "airports_reviewed": "レビュー済み空港",
  "total_reviews": "合計レビュー数",
  "registered_users": "登録ユーザー数",
  "join_community": "コミュニティに参加する",
  "top_contributors": "トップ貢献者",
  "view_all": "すべて見る",
  "recently_added": "最近追加された",
  "recently_reviewed": "最近レビューされた",
  "view_profile": "プロフィールを見る",
  "loading_reviews": "レビューを読み込み中...",
  "no_reviews": "まだレビューはありません。",
  "share_experience": "あなたの経験を共有する",
  "help_photographers": "あなたの空港での経験を共有して、他のフィルム写真家を助けましょう",
  "add_review": "レビューを追加",
  "airport_rankings": "空港ランキング",
  // Review tabs
  "all_reviews": "すべてのレビュー",
  "verified_reviews": "認証済みレビュー",
  "no_verified_reviews": "認証済みのレビューはまだありません。",
  "creative_reviews": "クリエイティブのレビュー",
  "traveler_reviews": "旅行者のレビュー",
  "no_creative_reviews": "認証済みクリエイティブからのレビューはまだありません。",
  "no_traveler_reviews": "認証済み旅行者からのレビューはまだありません。"
};
